export enum UNITY_POPUP_STATE {
  FULL,
  NO_ENERGY,
  NO_TREASURY,
  NO_POPUP,
}
